// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"305":"5c025fa9","742":"5f43632b"}[chunkId] || chunkId) + "." + {"192":"264a4282edf03d7c","305":"40ff771169b52667","695":"7238d531a5fd0ee4","742":"43ab383d3116867a"}[chunkId] + ".js";
};